import React, { useState } from 'react'
import './ImportContactsModal.scoped.sass'
import modalService from '@/services/modal.service'
// eslint-disable-next-line
import { ReactComponent as CloseIcon } from '@/assets/icons/close-icon.svg'
import { useCSVReader } from 'react-papaparse'
import contactsimportService from '@/app-domains/contacts/imports/contactsimport.service'
import contactsService from '@/app-domains/contacts/contacts.service'
import store from '@/core/store'
import { SimpleBanner } from '@/components/Banners/SimpleBanner'

const ImportContactsModal = () => {
  const { CSVReader } = useCSVReader()
  const [isFileUploaded, setIsFileUploaded] = useState(false)
  const [contactsToImport, setContactsToImport] = useState([])
  
  function getModalTitle () {
    return 'Import contacts'
  }

  async function importContacts () {
    for (const contact of contactsToImport) {
      await contactsService.addContact(contact)
    }
    store.commit('CONTACT_LIST:UPDATED', Object.values(contactsService.getAllStoredContacts()))
    modalService.close()
  }

  return (
    <div className='main-container'>
      <div className='top-header'>
        <span className='create-contact-header-text'>
          {getModalTitle()}
        </span>
        <div className='close-button' onClick={() => { modalService.close() }}>
          <CloseIcon />
        </div>
      </div>
      <div className='main-content'>
        <SimpleBanner type='info'> Import contact feature is currently in beta and we only allow importing <b>Gmail contacts</b></SimpleBanner>
      </div>
      <div className='container-csv'>
        <CSVReader
          onUploadAccepted={(results) => {
            setIsFileUploaded(true)
            const parsedContacts = contactsimportService.processGmailCSV(results)
            setContactsToImport(parsedContacts)
          }}
          config={{
            header: true
          }}
        >
          {({
            getRootProps,
            acceptedFile,
            getRemoveFileProps,
          }) => (
            <div className='contacts-import-container'>
              <div className='imported-file'>
                {acceptedFile && `File loaded : ${acceptedFile.name}`}
                <br/>
                {acceptedFile && `Contacts to import: ${contactsToImport.length}`}
              </div>
              <div className='contacts-import-container-buttons'>
                { !isFileUploaded && <button className='import-button' type='button' {...getRootProps()}>
                  Browse file
                </button> }
                {contactsToImport.length > 0 && <button onClick={importContacts} className='import-button'>Import Contacts</button>}
                
                { isFileUploaded && <button disabled={!isFileUploaded} className='remove-button' {...getRemoveFileProps()}>
                  Remove file
                </button> }
              </div>
            </div>
          )}
        </CSVReader>
      </div>
    </div>
  )
}

export default ImportContactsModal
